import React from 'react';

const SurveyTab = ({ courseDetails, handleChapterClick }) => {
    return (
        <div id="other-list">
            {courseDetails?.others?.length > 0 ? (
                courseDetails.others
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) // เรียงจากวันที่ล่าสุด
                    .map((item) => (
                        <div
                            key={item.uid}
                            className="other-item"
                            style={{
                                cursor: 'pointer',
                                padding: '20px 10px',
                                textAlign: 'left',
                                gap: '8px',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <div
                                style={{
                                    width: '100%',
                                    boxSizing: 'border-box',
                                    display: 'flex',
                                    gap: '24px',
                                    background: '#f2f2f2',
                                    border: '1px solid #cccccc',
                                    borderRadius: '16px',
                                    padding: '24px',
                                }}
                            >
                                <div className="custom-checkbox">
                                    <input
                                        type="checkbox"
                                        id={`checkbox_${item.uid}`} // กำหนด id ให้ checkbox เพื่อให้ label ทำงานได้
                                        checked={item.is_surveyed}
                                        disabled
                                    />
                                    <label htmlFor={`checkbox_${item.uid}`}></label>
                                </div>
                                <div style={{ display: 'flex', flexGrow: 1 }}>
                                    <p
                                        onClick={() => handleChapterClick(item.uid, item.course_uid)}
                                        style={{
                                            boxSizing: 'border-box',
                                            alignItems: 'center',
                                            wordWrap: 'break-word',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'normal',
                                            margin: '0',
                                            color: '#44526E',
                                            fontSize: '1vw',
                                        }}
                                    >
                                        {item.chapter}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))
            ) : null}
        </div>
    );
};

const styles = {
    
}

export default SurveyTab;
